import React from "react";

export default function DailyBriefingCard({ briefing, loading, onRefresh, compact = false, variant = "luxury" }) {
  const bullets = briefing?.bullets || [];
  const tasks = briefing?.tasks || [];
  const workspace = variant === "workspace";

  return (
    <section
      className={
        workspace
          ? `rounded-[2px] border border-[#edebe9] bg-white shadow-sm ${compact ? "p-3" : "p-4"}`
          : `nlq-surface rounded-2xl sm:rounded-[28px] ${compact ? "p-3" : "p-4 sm:p-5"}`
      }
    >
      <div
        className={`flex flex-col gap-2 ${workspace ? "min-[480px]:flex-row min-[480px]:items-start min-[480px]:justify-between min-[480px]:gap-3" : "gap-3 min-[400px]:flex-row min-[400px]:items-start min-[400px]:justify-between min-[400px]:gap-4"}`}
      >
        <div className="min-w-0 flex-1">
          <div
            className={
              workspace
                ? "text-[10px] font-semibold uppercase tracking-[0.14em] text-[#605e5c]"
                : "text-[11px] sm:text-[12px] tracking-[0.16em] sm:tracking-[0.18em] uppercase text-slate-500"
            }
          >
            Daily Briefing
          </div>
          <h2
            className={`mt-1 max-w-[28ch] font-medium tracking-tight text-slateLux-900 leading-snug text-balance pr-1 ${
              workspace ? "font-sans text-[13px]" : `font-serif tracking-[-0.02em] leading-[1.35] ${compact ? "text-[14px]" : "text-[15px] sm:text-[16px]"}`
            }`}
          >
            A calm snapshot of what matters.
          </h2>
        </div>
        <button
          type="button"
          onClick={onRefresh}
          className={
            workspace
              ? "h-8 shrink-0 self-start rounded-[2px] border border-[#edebe9] bg-white px-3 text-[11px] font-semibold text-[#323130] transition hover:bg-[#edebe9] disabled:opacity-50 w-full min-[480px]:w-auto"
              : "nlq-btn h-9 shrink-0 self-start px-4 text-[12px] w-full min-[400px]:w-auto"
          }
          disabled={loading}
        >
          {loading ? "Refreshing…" : "Refresh"}
        </button>
      </div>

      <div className={`grid grid-cols-1 gap-2 sm:gap-3 md:grid-cols-2 ${compact ? "mt-3" : workspace ? "mt-3" : "mt-4"}`}>
        <div
          className={`min-w-0 ${workspace ? "rounded-[2px] border border-[#edebe9] bg-[#faf9f8] p-3" : `rounded-2xl border border-pearl-200 bg-pearl-50 ${compact ? "p-3" : "p-3.5 sm:p-4"}`}`}
        >
          <div className={`font-semibold text-slateLux-800 ${workspace ? "text-[11px] uppercase tracking-wide" : "text-[12px]"}`}>
            Highlights
          </div>
          <ul className={`mt-2 space-y-1.5 text-[13px] text-slateLux-700 leading-snug break-words ${workspace ? "text-[12px]" : "leading-relaxed"}`}>
            {bullets.length === 0 ? (
              <li className="text-slate-500">{loading ? "Gathering your briefing…" : "No briefing available yet."}</li>
            ) : (
              bullets.map((b, i) => (
                <li key={i} className="flex gap-2">
                  <span
                    className={`mt-[5px] h-[5px] w-[5px] shrink-0 rounded-sm ${workspace ? "bg-[#0078d4]" : "rounded-full bg-accent-600"}`}
                  />
                  <span>{b}</span>
                </li>
              ))
            )}
          </ul>
        </div>
        <div
          className={`min-w-0 text-white ${workspace ? "rounded-[2px] border border-[#201f1e] bg-[#201f1e] p-3" : `rounded-2xl border border-white/10 bg-ink-900 ${compact ? "p-3" : "p-3.5 sm:p-4"}`}`}
        >
          <h3 className={`font-semibold leading-snug text-white/90 ${workspace ? "text-[11px] uppercase tracking-wide" : "text-[12px]"}`}>
            Suggested actions
          </h3>
          <div className="mt-2 space-y-1.5">
            {tasks.length === 0 ? (
              <div className={`leading-snug break-words text-white/70 ${workspace ? "text-[12px]" : "text-[13px] leading-relaxed"}`}>
                {loading ? "Scanning for action items…" : "Nothing urgent detected. You're in a good spot."}
              </div>
            ) : (
              tasks.map((t, idx) => (
                <div
                  key={idx}
                  className={`rounded-lg border border-white/10 bg-white/[0.06] px-2.5 py-1.5 transition hover:bg-white/10 ${workspace ? "" : "rounded-2xl px-3 py-2"}`}
                >
                  <div className={`font-semibold ${workspace ? "text-[12px]" : "text-[13px]"}`}>{t.subject}</div>
                  <div className={`mt-0.5 text-white/65 ${workspace ? "text-[11px]" : "text-[12px]"}`}>
                    From {t.from} • {t.receivedAt ? new Date(t.receivedAt).toLocaleString() : "recent"}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
